import { Link, makeStyles, Typography } from "@material-ui/core";
import { Formik } from "formik";
import React from "react";
import { useIntl } from "react-intl";
import { Link as RouterLink } from "react-router-dom";
import * as yup from "yup";
import { SubmitButton, TextField } from "../../components/formik";
import { confirmResetPassword } from "../../ducks/actions";
import { useQueryParams } from "../../hooks";
import useActionRequest from "../../hooks/useActionRequest";

const useStyles = makeStyles(theme => ({
  alignLeft: {
    alignSelf: "flex-start"
  },
  submitButton: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3)
  }
}));

const ResetPasswordForm = () => {
  const intl = useIntl();
  const classes = useStyles();

  const validationSchema = yup.object().shape({
    password: yup.string().required(),
    passwordConfirmation: yup.string().required()
  });
  const confirmResetPasswordRequest = useActionRequest({
    action: confirmResetPassword,
    redirect: "/login",
    successMessage: intl.formatMessage({
      id: "Auth.ResetPasswordForm.ConfirmResetPasswordSuccess",
      defaultMessage: "Password changed"
    }),
    errorMessage: intl.formatMessage({
      id: "Auth.ResetPasswordForm.ConfirmResetPasswordError",
      defaultMessage: "Password not changed"
    })
  });

  const [{ resetPasswordToken }] = useQueryParams();

  const onSubmit = value => confirmResetPasswordRequest({ ...value, resetPasswordToken });

  return (
    <Formik
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      initialValues={{ password: "", passwordConfirmation: "" }}
    >
      <>
        <Typography variant="h4" className={classes.alignLeft} gutterBottom>
          {intl.formatMessage({
            id: "Auth.ResetPasswordForm.ResetPassword",
            defaultMessage: "Reset Password"
          })}
        </Typography>
        <Typography variant="body1" className={classes.alignLeft}>
          {intl.formatMessage({
            id: "Auth.ResetPasswordForm.Helper",
            defaultMessage: "Enter the new password twice to change the password."
          })}
        </Typography>

        <TextField
          name="password"
          variant="outlined"
          type="password"
          label={intl.formatMessage({
            id: "Auth.ResetPasswordForm.NewPassword",
            defaultMessage: "New password"
          })}
          fullWidth
        />
        <TextField
          name="passwordConfirmation"
          variant="outlined"
          type="password"
          label={intl.formatMessage({
            id: "Auth.ResetPasswordForm.RepeatPassword",
            defaultMessage: "Repeat password"
          })}
          fullWidth
        />
        <SubmitButton
          variant="contained"
          color="primary"
          className={classes.submitButton}
          fullWidth
        >
          {intl.formatMessage({
            id: "Auth.ResetPasswordForm.ResetPassword",
            defaultMessage: "Reset Password"
          })}
        </SubmitButton>
        <Typography>
          {intl.formatMessage({
            id: "Auth.ResetPasswordForm.NeedHelp",
            defaultMessage: "Need help?"
          })}
          &nbsp;
          <Link to="/contact-us" component={RouterLink}>
            {intl.formatMessage({
              id: "Auth.ResetPasswordForm.ContactUs",
              defaultMessage: "Contact us."
            })}
          </Link>
        </Typography>
      </>
    </Formik>
  );
};

export default ResetPasswordForm;
